import { disputeDeflectionOutcome } from "@redotech/redo-dispute-db-schema/dispute-deflection-definition";
import { unaryRpc } from "@redotech/rpc/definition";
import * as z from "zod";

// Total count matching the same filters as getReclaimDeflections. Split out so
// the count is fetched independently and cached longer than the page query.
export const getReclaimDeflectionsCount = unaryRpc({
  name: "getReclaimDeflectionsCount" as const,
  input: z.object({
    outcomes: z.array(z.enum(disputeDeflectionOutcome)).optional(),
  }),
  output: z.object({ total: z.number().int() }),
});
